export const env: { [s: string]: (string | null); } = {
  'npm_package_version': '1.1.0',
  'AZ_FUNC_ENDPOINT': null,
  'NODE_ENV': 'production'
};
